import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled.div`
  .container {
    max-width: 1200px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 0px 16px;
  }
  .title-eng {
    font-size: 24px;
    font-weight: bold;
    color: #d3d3d3;
    line-height: 1.2;
  }
  .title {
    font-size: 48px;
    font-weight: bold;
    color: ${(props: any) => props.theme.palette.primary.dark};
    line-height: 1.2;
  }
  .subtitle {
    font-size: 24px;
    color: ${(props: any) => props.theme.palette.secondary.light};
    line-height: 1.2;
  }

  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .title-eng {
      font-size: 24px;
      text-align: center;
    }
    .title {
      font-size: 36px;
      text-align: center;
    }
    .subtitle {
      font-size: 18px;
      text-align: center;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .title-eng {
      font-size: 18px;
    }
    .title {
      font-size: 24px;
    }
    .subtitle {
      font-size: 18px;
    }
  }
`);
